import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TitleService {

    public title: string;

    public setTitleIfEmpty(title: string) {
        if (this.title === undefined) {
            this.title = title;
        }
    }
}
